.wrapper {
  position: relative;
  display: contents;
}

/* Bottom-right corner of the editor viewport — out of the way of toolbars,
 * sidebars, and chrome that mounts at the top.
 *
 * `position: fixed` (not absolute) keeps the dot pinned to the viewport even
 * when the editor scrolls; collab editors are typically full-page so this
 * matches the rest of the chrome's coordinate system.
 *
 * z-index sits below the OfflineBanner (1199) and DevBanner (1200) but above
 * normal editor surfaces.
 */
.statusOverlay {
  position: fixed;
  bottom: var(--tuna-spacing-2, 16px);
  right: var(--tuna-spacing-2, 16px);
  z-index: 1100;
  pointer-events: none;
  display: flex;
  align-items: center;
}
